export enum FieldDataType {
  ANY_CHARACTER = 'ANY_CHARACTER',
  NUMERIC = 'NUMERIC',
  DROPDOWN = 'DROPDOWN',
  BOOLEAN = 'BOOLEAN'
}
